'use client';

export { default } from './Breadcrumbs';
export { default as breadcrumbsClasses } from './breadcrumbsClasses';
export * from './breadcrumbsClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Breadcrumbs/index.js
// module id = 822
// module chunks = 22